import React from 'react'

import FormRow from '../components/FormRow'
import ImageSlider from '../components/ImageSlider'

import { Input, SelectCountry, FormFiles } from '../../ui/inputs'

export const AttendeeForm = ({
  media,
  bindInput,
  handleUpload,
  handleDelete,
}) => {
  return (
    <>
      <ImageSlider files={media.image} name="image" onChange={handleUpload} />

      <FormRow label="Upload Images">
        <FormFiles
          files={media.image}
          name="image"
          onChange={handleUpload}
          onDelete={handleDelete}
        />
      </FormRow>

      <FormRow label="Name">
        <Input placeholder="Name" {...bindInput('name')} />
      </FormRow>

      <FormRow label="Country">
        <SelectCountry {...bindInput('country')} />
      </FormRow>

      <FormRow label="Company">
        <Input placeholder="Company Name" {...bindInput('company')} />
      </FormRow>

      <FormRow label="Email">
        <Input placeholder="Email" {...bindInput('email')} />
      </FormRow>

      <FormRow label="Website">
        <Input placeholder="https://" {...bindInput('website')} />
      </FormRow>

      <FormRow label="Phone Number">
        <Input placeholder="+372 " {...bindInput('phone')} />
      </FormRow>
    </>
  )
}

export default AttendeeForm
